import { ActivityTemplate } from '@wilson/interfaces';

export function createFullActivityTemplateObject({
  defaultTimezone,
  partialActivityTemplate,
}: {
  defaultTimezone: string;
  partialActivityTemplate?: Partial<ActivityTemplate>;
}): ActivityTemplate {
  return {
    activityCategoryId: '',
    activityTemplateQualifications: null,
    endLocationId: '',
    name: '',
    serviceSeriesId: null,
    shiftSeriesId: null,
    startLocationId: '',
    viaLocationIds: [],
    startDatetime: '',
    endDatetime: '',
    startTimeZone: defaultTimezone,
    endTimeZone: defaultTimezone,
    cargo: null,
    track: null,
    note: null,
    numberOfWagons: null,
    tonnage: null,
    travelDirection: null,
    vehicleEmissionClassId: null,
    orderNumber: null,
    wagonNumber: null,
    locomotiveNumber: null,
    externalNumber: null,
    ...partialActivityTemplate,
  };
}
